import React from 'react'
import Campus from '../compus/Campus'
import First from '../firspage/First'
import What from '../whatweOffer/what'
import Footer from '../footer/Footer'
const Main = () => {
    return (
        <div className="main">
        <First />
        <What />
        <Campus />
        <Footer />
        </div>
    )
}

export default Main
